export const EARN_HEAD_STICKY_Z_INDEX = 'z-50';
